import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const API_BASE = '/planner-api';

export const fetchFuelPrices = createAsyncThunk(
  'fuelPrices/fetch',
  async ({ token, countries, fuelType }) => {
    const params = new URLSearchParams();
    if (countries && countries.length > 0) params.set('countries', countries.join(','));
    if (fuelType) params.set('fuelType', fuelType);

    const res = await fetch(`${API_BASE}/fuel-prices?${params.toString()}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error('Failed to fetch fuel prices');
    return res.json();
  }
);

const fuelPricesSlice = createSlice({
  name: 'fuelPrices',
  initialState: {
    prices: {},      // { PRT: { diesel: { price, currency, source } }, ... }
    overrides: {},   // { PRT: 1.65, ESP: 1.48 } — user overrides for current route
    loading: false,
    error: null,
  },
  reducers: {
    setFuelPriceOverride: (state, action) => {
      const { countryCode, price } = action.payload;
      state.overrides[countryCode] = price;
    },
    clearFuelPriceOverrides: (state) => {
      state.overrides = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFuelPrices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFuelPrices.fulfilled, (state, action) => {
        state.prices = action.payload;
        state.loading = false;
      })
      .addCase(fetchFuelPrices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setFuelPriceOverride, clearFuelPriceOverrides } = fuelPricesSlice.actions;

export const selectFuelPrices = (state) => state.fuelPrices.prices;
export const selectFuelPriceOverrides = (state) => state.fuelPrices.overrides;
export const selectFuelPricesLoading = (state) => state.fuelPrices.loading;

// Get effective price for a country (override > API price > fallback)
export const selectEffectiveFuelPrice = (countryCode, fuelType) => (state) => {
  if (state.fuelPrices.overrides[countryCode] != null) {
    return state.fuelPrices.overrides[countryCode];
  }
  const countryPrices = state.fuelPrices.prices[countryCode];
  if (countryPrices && countryPrices[fuelType]) {
    return countryPrices[fuelType].price;
  }
  return null;
};

export default fuelPricesSlice.reducer;
